import React, { Component } from 'react';
import Button from '~/UI/Button';
import buttonDestructiveStyles from '~/UI/Button/destructive.less';
import buttonSecondaryStyles from '~/UI/Button/secondary.less';
import Heading from '~/UI/Heading/Heading';
import ModalBody from '~/UI/Modal/Body/ModalBody';
import ModalContent from '~/UI/Modal/Content/ModalContent';
import ModalHeader from '~/UI/Modal/Header/ModalHeader';
import Modal from '~/UI/Modal/Modal';
import modalSmallStyles from '~/UI/Modal/small.less';

import styles from './styles.less';

interface Props {
	title: React.ReactNode;
	isFetching: boolean;
	onConfirm(): void;
	onClose(): void;
}

export default class DeleteModal extends Component<Props> {
	handleConfirmClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		event.preventDefault();
		this.props.onConfirm();
	};

	handleCancelClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		event.preventDefault();
		this.props.onClose();
	};

	render() {
		const { title, isFetching, onClose } = this.props;

		return (
			<Modal styles={modalSmallStyles} onClose={onClose}>
				<ModalContent>
					<ModalHeader>
						<Heading level={2}>{title}</Heading>
					</ModalHeader>
					<ModalBody>
						<form className={styles.container}>
							<Button disabled={isFetching} styles={buttonDestructiveStyles} onClick={this.handleConfirmClick}>
								Delete
							</Button>

							<div className={styles.cancelButtonContainer}>
								<Button disabled={isFetching} styles={buttonSecondaryStyles} onClick={this.handleCancelClick}>
									Cancel
								</Button>
							</div>
						</form>
					</ModalBody>
				</ModalContent>
			</Modal>
		);
	}
}
